<div id="modal-c" class="modal" *ngIf="showModal">
    <div class="modal-content">
      <span class="close" (click)="closeModal()">&times;</span>
      <p class="confirmation-message">{{ message }}</p>
      <div class="confirmation-buttons">
        <button class="confirm-button" (click)="closeModal()">OK</button>
      </div>
    </div>
  </div>
  